import React from "react";
import ReceiptHeader from "./View/ReceiptHeader";
import ReceiptTable from "./Table/ReceiptTable";
import GrandTotalBox from "./View/GrandTotalBox";
import "./Receipt.css";
import CommercialAirlineNavigationBar from "../../../../components/element/CommercialAirlineNavigationBar";
import invoiceLogo from "../../../../assets/images/invoicing-icon.svg";
import { Box } from "@mui/material";

const sampleRows = [
  {
    fee: "Special Onboarding Fee",
    qty: "2",
    unit: "$50",
    subTotal: "$100",
    vat: "$10",
    total: "$110",
  },
  {
    fee: "Landing Fee",
    qty: "1",
    unit: "$200",
    subTotal: "$200",
    vat: "$20",
    total: "$220",
  },
  {
    fee: "Parking Fee",
    qty: "1",
    unit: "$200",
    subTotal: "$200",
    vat: "$20",
    total: "$220",
  },
  {
    fee: "Overtime Fee",
    qty: "1",
    unit: "$200",
    subTotal: "$200",
    vat: "$20",
    total: "$220",
  },
];

const Receipt = () => {
  return (
    <Box className="receipt-container">
      <CommercialAirlineNavigationBar
        title={"Invoices for Delta Airline"}
        navigationLogo={invoiceLogo}
      />
      <Box className="center-content">
        <Box className="inner-container">
          <ReceiptHeader
            flightNumber="1234"
            destination="New York"
            dateTime="23/10/2024 at 19:00"
          />
          <ReceiptTable rows={sampleRows} />
          <GrandTotalBox grandTotal="$330" />
        </Box>
      </Box>
    </Box>
  );
};

export default Receipt;
